// Adds `NodeList.forEach` support for IE 11.

if (!NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach as any;
}